module.exports = __webpack_public_path__ + "img/sculpture-ceramics-bldg.826f3b23.jpg";